<template>
  <div>
    <!-- 一键收款弹框 -->
    <el-dialog title="收款" :visible="shouKuanMark" :close-on-click-modal="false" width="600px" center @close="closeDialog">
      <div class="addressBox">
        <div style="width:80%;margin:0 auto;">
          <el-form :inline="true" :rules="rules" :model="shouKuanFrom" ref="shouKuanFrom" class="demo-form-inline" label-width="130px" size="small">
            <el-form-item label="收款金额:">
              <span style="color:red;font-size:18px;margin-right:5px;">{{shouKuanFrom.collectionAmount}}</span><span>元</span>
            </el-form-item>
            <el-form-item label="收款时间:" prop="collectionTime">
              <el-date-picker
                v-model="shouKuanFrom.collectionTime"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm:ss"
                placeholder="选择日期时间">
              </el-date-picker>
            </el-form-item>
            <el-form-item label="收款凭证:" v-if="shouKuanMark" class="is-required">
              <uploadImgs :imgList.sync='imgList' style="margin-top:5px;" @remove='remove'></uploadImgs>
            </el-form-item>
          </el-form>
        </div>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click="closeDialog">取 消</el-button>
        <el-button type="primary" @click="shouKuanSubmitFn('shouKuanFrom')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {allPaymentForYs,wayPaymentForYs } from '@/api/newTMS'
import uploadImgs from '@/components/uploadImgs.vue'
export default{
  components: {
    uploadImgs,
  },
  props: {
    shouKuanMark: {
      type: Boolean,
      default: false
    },
    shouKuanFrom: {
      type: Object,
      default: function () {
        return {}
      }
    },
    detilsFlag: {
      type: Boolean,
      default: function () {
        return {}
      }
    },
  },
  data () {
    return {
      imgList:[],
      rules:{
        collectionTime: [
          { required: true, message: '请选择收款时间', trigger: 'blur' }
        ],
      }
    }
  },
  mounted () {
    console.log(this.shouKuanFrom,'this.shouKuanFrom')
  },
  methods: {
    // 删除图片
    remove (file) {
      console.log(file,'file')
    },
    closeDialog(){
      this.$emit('update:shouKuanMark', false)
      this.$refs.shouKuanFrom.resetFields()
    },
    shouKuanSubmitFn(formName){
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.imgList.length == 0 || this.imgList[0] == null) {
            this.$message({
              message: '收款凭证不能为空',
              type: 'error'
            })
            return
          }
          let imgfile = new FormData()
          if(this.imgList.length > 0){
            imgfile.set('files', this.imgList[0].raw)
          }
          imgfile.set('params', JSON.stringify(this.shouKuanFrom))
          console.log(this.shouKuanFrom,'shouKuanFrom')
          if(this.detilsFlag){
            this.wayPaymentYs(imgfile)
          }else{
            this.allPaymentYs(imgfile)
          }
        } else {
          return false
        }
      })
    },
    // 账单页面一键收款
    allPaymentYs(imgfile){
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      allPaymentForYs(imgfile).then(res => {
        loading.close()
        this.$message({
          message: '成功',
          type: 'success'
        })
        this.$emit('update:shouKuanMark', false)
        this.$emit('refresh')
        this.$refs.shouKuanFrom.resetFields()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    },
    // 账单详情点击收款按钮
    wayPaymentYs(imgfile){
      const loading = this.$loading({
        lock: true,
        text: '正在处理...'
      })
      wayPaymentForYs(imgfile).then(res => {
        loading.close()
        this.$message({
          message: '成功',
          type: 'success'
        })
        this.$emit('update:shouKuanMark', false)
        this.$emit('refresh')
        this.$refs.shouKuanFrom.resetFields()
      }).catch(error => {
        this.$message({
          showClose: true,
          message: error.message,
          type: 'error',
          onClose () {
            loading.close()
          }
        })
      })
    }
  }
}
</script>
<style scoped>

</style>